// extracted by mini-css-extract-plugin
export default {"root":"RKfB1gHE","auth":"E8OQC6jF","trigger":"PAmF0mqS"};